/**
 * Preparation Grid — opens the supplement facts accordion on CTA click.
 * The button targets `.supplement-facts__ingredients` (rendered by
 * blocks/_1-supplement-facts.liquid). It walks up to the ancestor <details>,
 * opens it (which triggers the existing accordion-custom toggle handler),
 * and smooth-scrolls the accordion summary into view.
 */
(function () {
  const TARGET_SELECTOR = '.supplement-facts__ingredients';

  class PreparationGrid extends HTMLElement {
    connectedCallback() {
      this.cta = this.querySelector('[data-open-supplement-facts]');
      if (!this.cta) return;
      this.isScrolling = false;
      this.cta.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      if (this.cta) this.cta.removeEventListener('click', this.handleClick);
    }

    handleClick = () => {
      if (this.isScrolling) return;

      const target = document.querySelector(TARGET_SELECTOR);
      if (!target) return;

      const details = target.closest('details');
      if (!details) return;

      if (!details.open) details.open = true;

      const summary = details.querySelector('summary') || details;
      this.isScrolling = true;

      // --header-height is set on <body> by assets/header.js; fall back to the
      // sticky <header-component> element's actual height (the var is forced to
      // 0px when the header detaches mid-scroll, so the live measurement is
      // more reliable for an in-page jump).
      const headerEl = document.querySelector('header-component');
      const headerHeight = headerEl
        ? headerEl.getBoundingClientRect().height
        : parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
      const top = summary.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });

      window.setTimeout(() => {
        this.isScrolling = false;
      }, 800);
    };
  }

  if (!customElements.get('one-client-preparation-grid')) {
    customElements.define('one-client-preparation-grid', PreparationGrid);
  }
})();
